/**
 * Country picker for the phone input.
 *
 * @param {Array<{ code: string, dialing_code: string, flag_url: string }>} countries
 * @param {string|null} initialCode
 * @param {string|null} wireModelName Livewire property that receives the selected country code.
 */
export default function phoneInput(countries = [], initialCode = null, wireModelName = null) {
    const fallback = countries[0] ?? { code: 'SA', dialing_code: '+966', flag_url: '' };
    const initialCountry = countries.find((country) => country.code === initialCode) ?? fallback;

    return {
        countries,
        selectedCountryCode: initialCountry.code,
        selectedDialingCode: initialCountry.dialing_code,
        selectedFlagUrl: initialCountry.flag_url,

        selectCountry(country) {
            this.selectedCountryCode = country.code;
            this.selectedDialingCode = country.dialing_code;
            this.selectedFlagUrl = country.flag_url;

            if (wireModelName) {
                this.$wire.set(wireModelName, country.code);
            }
        },
    };
}
